<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <h6>Agenda de Contactos</h6>
          <v-spacer></v-spacer>
          <v-btn tile color="red" @click="nuevoContacto()">Nuevo Contacto</v-btn>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <v-text-field label="Filtro por Razón Social" dense v-model="filtrorazon">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field label="Filtro por Nombre" dense v-model="filtronombre">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row align="center" justify="space-around">
            <v-btn tile color="success" @click="cargarListado(filtrorazon, filtronombre)">
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-data-table dense :headers="headers" :items="listadocontacto" locale="es-ar" class="elevation-1"
        :items-per-page="100" :footer-props="{
          itemsPerPageText: 'Contactos por página',
        }">
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="editarInforme(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar contacto</span>
          </v-tooltip>
          <v-icon small color="red" @click="BorrarContacto(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <Editarcontacto :visible="showInforme" :id="editedItem.id" @close="showInforme = false"></Editarcontacto>
      <Nuevocontacto :visible="showNuevo" @close="showNuevo = false"></Nuevocontacto>
    </v-app>
  </div>
</template>

<script>
import Editarcontacto from "./Editarcontacto.vue";
import Nuevocontacto from "./Nuevocontacto.vue";
import axios from "../../../src/axios-auth";
import NuevocontactoVue from './Nuevocontacto.vue';
export default {
  data: (vm) => ({
    filtrorazon: "",
    filtronombre: "",
    listadocontacto: [],
    editedItem: {},
    editedIndex: -1,
    headers: [
      { text: "Id", value: "id", sortable: false },
      { text: "Razón Social", value: "razonSocial", sortable: false },
      { text: "Nombre de Contacto", value: "contacto", sortable: false },
      { text: "Dirección", value: "direccion", sortable: false },
      { text: "Teléfono", value: "tel", sortable: false },
      { text: "Mail", value: "mail", sortable: false },
      { text: "Acciones", value: "actions", align: "center", sortable: false },
    ],
    showInforme: false,
    showNuevo: false,
  }),
  created() {
    this.usuario = this.$store.state.usuario.toString().trim();
  },
  components: { Editarcontacto, Nuevocontacto },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    editarInforme(item) {
      this.editedIndex = this.listadocontacto.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showInforme = true;
    },
    nuevoContacto() {

      this.showNuevo = true;
    },
    BorrarContacto(item) {
      this.$swal({
        title: "Borrar Contacto",
        text: "¿Desea borrar el contacto?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const Id = item.id;

          let self = this;
          axios
            .get("/Icssa/BorrarContacto?", {
              params: {
                Id: Id,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Contacto borrado",
                vm: this,
              });
              setTimeout(self.cargarListado(), 1700);
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El contacto no pudo ser borrado",
                vm: this,
              });
            });
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 1500,
      });
    },
    cargarListado() {
      const filtrorazon = this.filtrorazon;
      const filtronombre = this.filtronombre;
      let self = this;
      axios
        .get("/Icssa/ListadoContactos?", {
          params: {
            filtrorazon: filtrorazon,
            filtronombre: filtronombre,
          },
        })
        .then((response) => {
          self.listadocontacto = response.data;
        })
        .catch((error) => {
          self.listadocontacto = [];
          console.log(error);
        });
    },
  },
};
</script>
